export default __webpack_public_path__ + "static/media/work-4a.94c6d532.png";